import MilestonesToggleCompleteController from "../../../../javascript/stimulusControllers/milestones/milestones-toggle-complete-controller";

export default class extends MilestonesToggleCompleteController {
  connect() {
    this.toggleCompleted = this.toggleCompleted.bind(this);
    App.Helpers.listenToCustomEvent(document, "milestones:toggle-all-complete", this.toggleCompleted);
  }

  toggleCompleted(event) {
    const { all, showComplete } = (event.detail || {});
    this.showComplete = all ? !showComplete : this.showComplete;
    super.toggleCompleted(event)
  }

  //
  // GETTERS AND SETTERS
  //

  get milestoneID() {
    return this.data.get("milestone-id");
  }

  get eventName() {
    return "milestone:toggle-complete";
  }

  get eventDetail() {
    return { milestoneID: this.milestoneID, showComplete: this.showComplete };
  }
};



// WEBPACK FOOTER //
// ./app/components/milestones/assets/javascript/milestones-card-header-controller.js